// const products = [
//   {
//     name: 'Ashwagandha Capsule',
//     images: {
//       // back: 'images/extracts/ashwagandha.webp',
//       front: 'images/products/ashwagandha-capsule.webp',
//     },
//     description: '',
//     disclaimer: '',
//     seo_title: '',
//     seo_description: '',
//     seo_slug: 'ashwagandha-capsule',
//     category: ['Uncategorised'],
//   },
//   {
//     name: 'Quercetin capsule',
//     images: {
//       // back: 'images/extracts/quercetin.webp',
//       front: 'images/products/quercetin.webp',
//     },
//     description: '',

//     disclaimer: '',
//     seo_title: '',
//     seo_description: '',
//     seo_slug: 'quercetin-capsule',
//     category: ['Vision', 'Weight Management'],
//   },
//   {
//     name: 'Gingerol capsule',
//     images: {
//       // back: 'images/extracts/gingeroil.webp',
//       front: 'images/products/gingerol.webp',
//     },
//     description: '',

//     disclaimer: '',
//     seo_title: '',
//     seo_description: '',
//     seo_slug: 'gingerol-capsule',
//     category: [
//       'Gut and Digestive Health',
//       'Hairs Nails & Skin',
//       'Heart Health',
//     ],
//   },
//   {
//     name: 'Hesperidin Capsule',
//     images: {
//       // back: 'images/extracts/hesperidin.webp',
//       front: 'images/products/hesperidin.webp',
//     },
//     description: '',

//     disclaimer: '',
//     seo_title: '',
//     seo_description: '',
//     seo_slug: 'hesperidin-capsule',
//     category: [
//       'Immune System',
//       'Pregnancy Care',
//       'Sleep Aid',
//       'Vision',
//       'Weight Management',
//     ],
//   },
//   {
//     name: 'EGCG Tablet',
//     images: {
//       // back: 'images/extracts/EGCG-Extract.webp',
//       front: 'images/products/egcg.webp',
//     },
//     description: '',

//     disclaimer: '',
//     seo_title: '',
//     seo_description: '',
//     seo_slug: 'egcg-tablet',
//     category: [
//       'Bones and Joints',
//       'Brain and Cognitive Health',
//       'Daily Wellness',
//       'Gut and Digestive Health',
//       'Hairs Nails & Skin',
//       'Heart Health',
//       'Immune System',
//       'Pregnancy Care',
//       'Sleep Aid',
//       'Vision',
//       'Weight Management',
//     ],
//   },
// ];

const categoryDetails = [
  {
    productHeading: 'Blood Glucose',
    productSubHeading: 'maintain healthy blood sugar levels naturally',
    productDescription:
      'At Natural Treasure Labs, our Blood Glucose Support supplements are thoughtfully crafted to help maintain healthy blood sugar levels naturally. Formulated with clinically researched ingredients like chromium, berberine, cinnamon extract, and fenugreek, our products support insulin function and glucose metabolism. Ideal for individuals looking to manage energy fluctuations or support metabolic health, these supplements complement a healthy lifestyle. Backed by science and quality-tested, our formulations aim to promote overall wellness. Trust Natural Treasure Labs for your daily blood sugar balance. ',
    productDummyContent: 'Blood Glucose',
    productImage: 'images/category/blood-glucose.webp',
  },
  {
    productHeading: 'Bones and Joints',
    productSubHeading: 'maintain bone density & promote joint comfort',
    productDescription:
      'At Natural Treasure Labs, our Bones and Joint Health supplements are designed to support mobility, flexibility, and overall skeletal strength. Enriched with key nutrients like calcium, vitamin D3, magnesium, collagen, and glucosamine, our formulations help maintain bone density and promote joint comfort',
    productDummyContent: 'Bones and Joints',
    productImage: 'images/category/bones-joints.webp',
  },
  {
    productHeading: 'Brain and Cognitive Health',
    productSubHeading: 'enhance cognitive performance',
    productDescription:
      'At Natural Treasure Labs, our Brain and Cognitive Health supplements are expertly formulated to support mental clarity, focus, memory, and overall brain function. Infused with powerful ingredients like bacopa monnieri, ginkgo biloba, omega-3 fatty acids, and B-vitamins, our products help enhance cognitive performance and reduce mental fatigue. ',
    productDummyContent: 'Brain and Cognitive Health',
    productImage: 'images/category/brain.webp',
  },
  {
    productHeading: 'Daily Wellness',
    productSubHeading: 'enhance overall well-being',
    productDescription:
      'At Natural Treasure Labs, our Daily Wellness supplements are crafted to support overall health, energy, and vitality for everyday living. Packed with essential vitamins, minerals, antioxidants, and herbal extracts, these formulations help strengthen immunity, boost metabolism, and enhance overall well-being.',
    productDummyContent: 'Daily Wellness',
    productImage: 'images/category/daily-wellness.webp',
  },
  {
    productHeading: 'Gut and Digestive Health',
    productSubHeading: 'promote a healthy digestive system',
    productDescription:
      'At Natural Treasure Labs, our Gut and Digestive Health supplements are specially formulated to promote a healthy digestive system and balanced gut flora. Enriched with probiotics, prebiotics, digestive enzymes, and herbal extracts like ginger and fennel, our products support smooth digestion, nutrient absorption, and relief from bloating or discomfort.',
    productDummyContent: 'Gut and Digestive Health',
    productImage: 'images/category/guts.webp',
  },
  {
    productHeading: 'Hair, Nails and Skin',
    productSubHeading: 'nourish beauty from within',
    productDescription:
      'At Natural Treasure Labs, our Hair, Nails and Skin supplements are thoughtfully developed to nourish beauty from within. Infused with biotin, collagen, hyaluronic acid, vitamins A, C, E, and essential minerals, these formulations support healthy hair growth, stronger nails, and radiant skin.',
    productDummyContent: 'Hair, Nails and Skin',
    productImage: 'images/category/hair.webp',
  },
  {
    productHeading: 'Heart Health',
    productSubHeading: 'help maintain healthy blood pressure and circulation',
    productDescription:
      'At Natural Treasure Labs, our Heart Health supplements are expertly formulated to support cardiovascular function, healthy cholesterol levels, and overall heart wellness. Powered by essential nutrients like omega-3 fatty acids, CoQ10, magnesium, and plant sterols, our products help maintain healthy blood pressure and circulation.',
    productDummyContent: 'Heart Health',
    productImage: 'images/category/heart.webp',
  },
  {
    productHeading: 'Immune System',
    productSubHeading: 'crafted to strengthen your body’s defense mechanisms',
    productDescription:
      'At Natural Treasure Labs, our Immune System supplements are carefully crafted to strengthen your body’s natural defense mechanisms. Formulated with immune-boosting ingredients like vitamin C, vitamin D3, zinc, elderberry, and herbal extracts, our products help protect against everyday health challenges.',
    productDummyContent: 'Immune System',
    productImage: 'images/category/immune-system.webp',
  },
  {
    productHeading: 'Pregnancy Care',
    productSubHeading: 'and well-being of both mother and baby ',
    productDescription:
      'At Natural Treasure Labs, our Pregnancy Care supplements are thoughtfully formulated to support the health and well-being of both mother and baby throughout every stage of pregnancy. Enriched with essential nutrients like folic acid, iron, calcium, DHA, and multivitamins, our products help promote fetal development, boost maternal energy, and maintain overall wellness',
    productDummyContent: 'Pregnancy Care',
    productImage: 'images/category/pregnancy.webp',
  },
  {
    productHeading: 'Sleep Aid',
    productSubHeading:
      'calm the mind, reduce stress, & support a healthy sleep cycle',
    productDescription:
      'At Natural Treasure Labs, our Sleep Aid supplements are carefully formulated to promote restful, uninterrupted sleep and improved sleep quality. Blended with natural ingredients like melatonin, valerian root, chamomile, and magnesium, our products help calm the mind, reduce stress, and support a healthy sleep cycle.',
    productDummyContent: 'Sleep Aid',
    productImage: 'images/category/sleep-aid.webp',
  },
  {
    productHeading: 'Vision',
    productSubHeading: 'protect against age-related vision concerns',
    productDescription:
      'At Natural Treasure Labs, our Vision Support supplements are specially crafted to promote eye health and protect against age-related vision concerns. Enriched with key nutrients like lutein, zeaxanthin, vitamin A, zinc, and bilberry extract, our formulations help support retinal health, reduce eye strain, and enhance visual clarity.',
    productDummyContent: 'Vision',
    productImage: 'images/category/vision.webp',
  },
  {
    productHeading: 'Weight Management',
    productSubHeading:
      'scientifically formulated to support healthy metabolism',
    productDescription:
      'At Natural Treasure Labs, our Weight Management supplements are scientifically formulated to support healthy metabolism, fat burning, and appetite control. Featuring powerful ingredients like green tea extract, Garcinia cambogia, L-carnitine, our products help boost energy levels and promote effective weight loss when combined with a balanced diet and exercise.',
    productDummyContent: 'Weight Management',
    productImage: 'images/category/weight-management.webp',
  },
  {
    productHeading: 'Uncategorised',
    productSubHeading: 'Wellness You Can Trust!',
    productDescription:
      'Our capsules are crafted to meet the highest standards of purity and ethical sourcing, making them the ideal choice for today’s health-conscious consumers. Here’s what sets our vegetarian, preservative-free capsules apart',
    productImage: 'images/capsule-image.webp',
  },
];

const products = [
  {
    name: 'Ashwagandha Capsule',
    images: {
      // back: 'images/extracts/ashwagandha.webp',
      front: 'images/products/ashwagandha-capsule.webp',
    },
    description: '',
    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'ashwagandha-capsule',
    category: ['Heart Health', 'Immune System'],
  },
  // {
  //   name: 'Thymoquinone',
  //   images: {
  //     back: 'images/extracts/thymoquinone.webp',
  //     front: 'images/products/thymoquinone.webp',
  //   },
  //   description: '',

  //   disclaimer: '',
  //   seo_title: '',
  //   seo_description: '',
  //   seo_slug: 'Thymoquinone',
  // category: ['Uncategorised'],
  // },
  {
    name: 'Quercetin capsule',
    images: {
      // back: 'images/extracts/quercetin.webp',
      front: 'images/products/quercetin.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'quercetin-capsule',
    category: ['Heart Health', 'Immune System'],
  },
  {
    name: 'Gingerol capsule',
    images: {
      // back: 'images/extracts/gingeroil.webp',
      front: 'images/products/gingerol.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'gingerol-capsule',
    category: ['Immune System'],
  },
  {
    name: 'Hesperidin Capsule',
    images: {
      // back: 'images/extracts/hesperidin.webp',
      front: 'images/products/hesperidin.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'hesperidin-capsule',
    category: ['Bones and Joints', 'Heart Health'],
  },
  // {
  //   name: 'Fisetin Tablet',
  //   images: {
  //     back: 'images/extracts/fisetin.webp',
  //     front: 'images/products/fisetin-tablet.webp',
  //   },
  //   description: '',

  //   disclaimer: '',
  //   seo_title: '',
  //   seo_description: '',
  //   seo_slug: 'fisetin-tablet',
  // category: ['Uncategorised'],
  // },
  {
    name: 'EGCG Tablet',
    images: {
      // back: 'images/extracts/EGCG-Extract.webp',
      front: 'images/products/egcg.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'egcg-tablet',
    category: ['Heart Health'],
  },
  {
    name: 'Allicin Capsules',
    images: {
      // back: 'images/extracts/allicin.webp',
      front: 'images/products/allicin.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'allicin-capsules',
    category: ['Heart Health'],
  },
  {
    name: 'Panax Ginseng capsule',
    images: {
      // back: 'images/extracts/panax.webp',
      front: 'images/products/panax.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'panax-ginseng-capsule',
    category: ['Immune System'],
  },
  {
    name: 'Rutin Capsules',
    images: {
      // back: 'images/extracts/rutin.webp',
      front: 'images/products/rutin.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'rutin-capsules',
    category: ['Heart Health'],
  },
  {
    name: 'Silymarin Capsules',
    images: {
      // back: 'images/extracts/silymarin.webp',
      front: 'images/products/silymarin.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'silymarin-capsules',
    category: ['Gut and Digestive Health'],
  },
  {
    name: 'Resveratrol Capsules',
    images: {
      // back: 'images/extracts/resveratrol.webp',
      front: 'images/products/resveratrol.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'resveratrol-capsules',
    category: ['Hair, Nails and Skin'],
  },
  {
    name: 'Chrysin Tablets',
    images: {
      // back: 'images/extracts/chrysin.webp',
      front: 'images/products/chrysin.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'chrysin-tablets',
    category: ['Immune System'],
  },
  {
    name: 'Apigenin Tablets',
    images: {
      // back: 'images/extracts/apigenin.webp',
      front: 'images/products/apigenin.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'apigenin-tablets',
    category: ['Heart Health'],
  },
  {
    name: 'Curcumin Capsules',
    images: {
      // back: 'images/extracts/curcumin.webp',
      front: 'images/products/curcumin.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'curcumin-capsules',
    category: ['Bones and Joints', 'Brain and Cognitive Health'],
  },
  // {
  //   name: 'Myricetin Capsules',
  //   images: {
  //     back: 'images/extracts/rosmarinic.webp',
  //     front: 'images/products/myricetin.webp',
  //   },
  //   description: '',

  //   disclaimer: '',
  //   seo_title: '',
  //   seo_description: '',
  //   seo_slug: 'myricetin-capsules',
  // category: ['Uncategorised'],
  // },
  {
    name: 'Rosmarinic Acid Tablets',
    images: {
      // back: 'images/extracts/rosmarinic.webp',
      front: 'images/products/rosmarinic.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'rosmarinic-acid',
    category: ['Brain and Cognitive Health', 'Sleep Aid'],
  },
  // {
  //   name: 'Carvacrol Tablets',
  //   images: {
  //     back: 'images/extracts/carvacrol.webp',
  //     front: 'images/products/carvacrol.webp',
  //   },
  //   description: '',

  //   disclaimer: '',
  //   seo_title: '',
  //   seo_description: '',
  //   seo_slug: 'carvacrol-tablets',
  // category: ['Uncategorised'],
  // },
  {
    name: 'Naringin Capsules',
    images: {
      // back: 'images/extracts/naringin.webp',
      front: 'images/products/naringin.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'naringin-capsules',
    category: ['Bones and Joints'],
  },
  {
    name: 'Baicalein Capsules',
    images: {
      // back: 'images/extracts/baicalein.webp',
      front: 'images/products/baicalein.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'baicalein-capsules',
    category: ['Heart Health'],
  },
  {
    name: 'Clove Capsules',
    images: {
      // back: 'images/extracts/clove.webp',
      front: 'images/products/clove.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'clove-capsules',
    category: ['Bones and Joints'],
  },
  {
    name: 'Genistein Capsules',
    images: {
      // back: 'images/extracts/genistein.webp',
      front: 'images/products/genistein.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'genistein-capsules',
    category: ['Bones and Joints'],
  },
  {
    name: 'Thymol capsule',
    images: {
      // back: 'images/extracts/thymol.webp',
      front: 'images/products/thymol.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'thymol-capsule',
    category: ['Heart Health'],
  },
  {
    name: 'ursolic acid capsule',
    images: {
      // back: 'images/extracts/ursolic-acid.webp',
      front: 'images/products/ursolic.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'ursolic-acid',
    category: ['Brain and Cognitive Health'],
  },
  {
    name: 'Beta Carotene tablet',
    images: {
      // back: 'images/extracts/beta-carotene.webp',
      front: 'images/products/beta.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'beta-carotene-tablet',
    category: ['Vision'],
  },
  // {
  //   name: 'Kaempferol capsule',
  //   images: {
  //     back: 'images/extracts/kaempferol.webp',
  //     front: 'images/products/kaempferol.webp',
  //   },
  //   description: '',

  //   disclaimer: '',
  //   seo_title: '',
  //   seo_description: '',
  //   seo_slug: 'kaempferol-capsule',
  // category: ['Uncategorised'],
  // },
  {
    name: 'Berberine capsule',
    images: {
      // back: 'images/extracts/berberine.webp',
      front: 'images/products/berberine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'berberine',
    category: ['Blood Glucose'],
  },
  {
    name: 'Astragaloside IV capsule',
    images: {
      // back: 'images/extracts/astragaloside.webp',
      front: 'images/products/astragaloside.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'astragaloside',
    category: ['Heart Health'],
  },
  {
    name: 'Lycopene capsule',
    images: {
      // back: 'images/extracts/lycopene.webp',
      front: 'images/products/lycopene.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'lycopene-capsule',
    category: ['Hair, Nails and Skin'],
  },
  {
    name: 'Sulphoraphane capsule',
    images: {
      // back: 'images/extracts/genistein.webp',
      front: 'images/products/sulphoraphane.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'sulphoraphane-capsule',
    category: ['Heart Health'],
  },
  {
    name: 'Coenzyme Q10 capsule',
    images: {
      // back: 'images/extracts/genistein.webp',
      front: 'images/products/coenzyme.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'coenzyme-Q10-capsule',
    category: ['Heart Health'],
  },
  {
    name: 'Ginkgo Biloba capsules',
    images: {
      // back: 'images/extracts/ginkgo-biloba.webp',
      front: 'images/products/ginkgo.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'ginkgo-biloba-capsules',
    category: ['Heart Health', 'Brain and Cognitive Health'],
  },
  {
    name: 'Brahmi capsule',
    images: {
      // back: 'images/extracts/genistein.webp',
      front: 'images/products/brahmi.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'brahmi-capsule',
    category: ['Brain and Cognitive Health'],
  },
  {
    name: 'Cinnamon capsule',
    images: {
      // back: 'images/extracts/cinnamon.webp',
      front: 'images/products/brahmi.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'cinnamon-capsule',
    category: ['Blood Glucose'],
  },
  {
    name: 'Garcinia Cambogia capsule',
    images: {
      // back: 'images/extracts/Garcinia.webp',
      front: 'images/products/garcinia.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'garcinia-cambogia-capsule',
    category: ['Weight Management'],
  },
  {
    name: 'Moringa capsule',
    images: {
      // back: 'images/extracts/moringa.webp',
      front: 'images/products/moringa.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'moringa-capsule',
    category: ['Blood Glucose'],
  },
  {
    name: 'Gotu Kola capsule',
    images: {
      // back: 'images/extracts/genistein.webp',
      front: 'images/products/gotu-kola.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'gotu-kola-capsule',
    category: ['Brain and Cognitive Health', 'Sleep Aid'],
  },
  {
    name: 'Melatonin tablet',
    images: {
      // back: 'images/extracts/melatonin.webp',
      front: 'images/products/melatonin.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'melatonin-tablet',
    category: ['Sleep Aid'],
  },
  {
    name: 'Piperine capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/piperine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'piperine-capsule',
    category: ['Immune System'],
  },
  {
    name: 'L-Histidine capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/l-histidine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-histidine',
    category: ['Brain and Cognitive Health'],
  },
  {
    name: 'L-Isoleucine capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/l-isoleucine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-isoleucine',
    category: ['Blood Glucose', 'Daily Wellness'],
  },
  {
    name: 'L-Leucine capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/l-leucine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-leucine',
    category: ['Uncategorised'],
  },
  {
    name: 'L-Lysine capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/l-lysine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-lysine',
    category: ['Bones and Joints'],
  },
  {
    name: 'L-Methionine capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/l-methionine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-methionine',
    category: ['Uncategorised'],
  },
  {
    name: 'L-Phenylalanine capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/l-phenylalanne.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-phenylalanine',
    category: ['Brain and Cognitive Health'],
  },
  {
    name: 'L-Threonine capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/l-threonine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-threonine',
    category: ['Uncategorised'],
  },
  {
    name: 'L-Tryptophan capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/l-tryptophan.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-tryptophan',
    category: ['Sleep Aid'],
  },
  {
    name: 'L-Valine capsules',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/l-valine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-valine',
    category: ['Uncategorised'],
  },
  {
    name: 'L-Alanine capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/piperine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-alanine',
    category: ['Uncategorised'],
  },
  {
    name: 'L-Glycine Capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/piperine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-glycine',
    category: ['Daily Wellness', 'Sleep Aid'],
  },
  {
    name: 'L-Arginine Capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/piperine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-arginine',
    category: ['Uncategorised'],
  },
  {
    name: 'L-Aspartic Acid Capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/piperine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-aspartic-acid',
    category: ['Immune System'],
  },
  {
    name: 'L-Glutamic Acid Capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/piperine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-glutamic-acid',
    category: ['Uncategorised'],
  },
  {
    name: 'L-Histidine Capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/l-histidine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-histidine-capsule',
    category: ['Brain and Cognitive Health'],
  },
  {
    name: 'L-Serine Capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/piperine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'l-serine',
    category: ['Brain and Cognitive Health'],
  },
  {
    name: 'N-Acetyl L-Cysteine Capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/piperine.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'n-acetyl-l-cysteine',
    category: ['Immune System'],
  },
  {
    name: 'Vitamin A',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-a.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-a',
    category: ['Vision'],
  },
  {
    name: 'Vitamin B1',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-b1.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-b1',
    category: ['Brain and Cognitive Health'],
  },
  {
    name: 'Vitamin B2',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-b2.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-b2',
    category: ['Uncategorised'],
  },
  {
    name: 'Vitamin B3',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-b3.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-b3',
    category: ['Hair, Nails and Skin', 'Heart Health'],
  },
  {
    name: 'Vitamin B5',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-b5.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-b5',
    category: ['Hair, Nails and Skin'],
  },
  {
    name: 'Vitamin B6',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-b6.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-b6',
    category: ['Immune System'],
  },
  {
    name: 'Vitamin B7',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-b7.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-b7',
    category: ['Uncategorised'],
  },
  {
    name: 'Vitamin B9',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-b3.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-b9',
    category: ['Heart Health'],
  },
  {
    name: 'Vitamin B12',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-b12.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-b12',
    category: ['Bones and Joints'],
  },
  {
    name: 'Vitamin C',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-c.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-c',
    category: ['Immune System'],
  },
  {
    name: 'Vitamin D3',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-d3.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-d3',
    category: ['Bones and Joints'],
  },
  {
    name: 'Vitamin E',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-e.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-e',
    category: ['Hair, Nails and Skin', 'Vision'],
  },
  {
    name: 'Vitamin K2-MK7',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/vitamin-b3.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'vitamin-k2-mk7',
    category: ['Bones and Joints'],
  },
  {
    name: 'Calcium Capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/calcium.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'calcium-capsule',
    category: ['Uncategorised'],
  },
  {
    name: 'Chromium Picolinate tablet',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/chromium.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'chromium-picolinate-tablet',
    category: ['Weight Management', 'Blood Glucose'],
  },
  {
    name: 'Copper Tablet',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/copper.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'copper-tablet',
    category: ['Bones and Joints'],
  },
  {
    name: 'Iodine Tablet',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/calcium.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'iodine-tablet',
    category: ['Uncategorised'],
  },
  {
    name: 'Iron Tablet',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/iron.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'iron-tablet',
    category: ['Immune System'],
  },
  {
    name: 'Magnesium Capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/magnesium.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'magnesium-capsule',
    category: ['Brain and Cognitive Health', 'Sleep Aid'],
  },
  {
    name: 'Manganese Tablet',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/manganese.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'manganese-tablet',
    category: ['Uncategorised'],
  },
  {
    name: 'Molybdenum Tablet',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/molybdenum.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'molybdenum-tablet',
    category: ['Gut and Digestive Health'],
  },
  {
    name: 'Phosphorus Capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/phosphorus.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'phosphorus-capsule',
    category: ['Bones and Joints'],
  },
  {
    name: 'Potassium Capsule',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/calcium.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'potassium-capsule',
    category: ['Uncategorised'],
  },
  {
    name: 'Selenium Tablet',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/selemium.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'selenium-tablet',
    category: ['Immune System'],
  },
  {
    name: 'Zinc Tablet',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/zinc.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'zinc-tablet',
    category: ['Hair, Nails and Skin'],
  },
  {
    name: 'Boron Tablet',
    images: {
      // back: 'images/extracts/piperine.webp',
      front: 'images/products/zinc.webp',
    },
    description: '',

    disclaimer: '',
    seo_title: '',
    seo_description: '',
    seo_slug: 'boron-tablet',
    category: ['Bones and Joints'],
  },
];

const categoriesSet = new Set();
products.forEach((product) => {
  product.category.forEach((cat) => categoriesSet.add(cat));
});
const categories = Array.from(categoriesSet).sort();

const columns = [
  document.getElementById('mega-col-1'),
  document.getElementById('mega-col-2'),
  document.getElementById('mega-col-3'),
];
const categoriesPerCol = Math.ceil(categories.length / columns.length);

categories.forEach((cat, i) => {
  const colIdx = Math.floor(i / categoriesPerCol);
  const li = document.createElement('li');
  li.innerHTML = `<a class="dropdown-item" href="our-products.html?category=${encodeURIComponent(
    cat
  )}">${cat}</a>`;
  columns[colIdx].appendChild(li);
});

function getSlugFromUrl() {
  const query = new URLSearchParams(window.location.search);
  return query.keys().next().value;
}

document.addEventListener('DOMContentLoaded', () => {
  // Get category from URL query param
  const query = new URLSearchParams(window.location.search);
  const categoryFilter = query.get('category');

  const selectedCategoryName = document.getElementById('selectedCategoryName');
  selectedCategoryName.innerHTML = categoryFilter || 'All Products';

  if (categoryFilter) {
    const categoryInfo = categoryDetails.find(
      (cat) => cat.productHeading.toLowerCase() === categoryFilter.toLowerCase()
    );

    if (categoryInfo) {
      // Replace the entire H1 with template string
      document.getElementById('productSubHeading').innerHTML = `
      <span id="productHeading">${categoryInfo.productHeading}</span>
      ${categoryInfo.productSubHeading}
    `;

      document.getElementById('productDescription').innerText =
        categoryInfo.productDescription;

      document.getElementById('dummyContent').innerText =
        categoryInfo.productDummyContent;

      document.getElementById('categoryImage').src = categoryInfo.productImage;
    }
  }

  // Clear existing products container if any
  const container = document.getElementById('ourProducts');
  container.innerHTML = '';

  // Filter products based on categoryFilter if exists
  const filteredProducts = categoryFilter
    ? products.filter((product) => product.category.includes(categoryFilter))
    : products; // if no filter, show all

  // Render filtered products
  filteredProducts.forEach((product) => {
    const productHTML = `
      <div class="home-product__product-container home-product__product-container--margin-top">
        <div class="home-product__product-img">
          <div class="home-product__front-img">
            <img src="${product.images.front}" alt="${
      product.name
    } Front Image" />
          </div>
        </div>
        <div class="home-product__product-description">
          <p class="text-highlighted">${product.name}</p>
          <p>${product.description}</p>
          <p style="display:none" class="product-categories">${product.category
            .map((c) => `<span>${c}</span>`)
            .join(', ')}</p>
          <a href="./reflect-product-details.html?${
            product.seo_slug
          }" class="btn btn-outline-success">know more</a>
        </div>
      </div>
    `;
    container.insertAdjacentHTML('beforeend', productHTML);
  });
});
